import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class DonationsByCenter extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.showColumn = this.showColumn.bind(this);
		this.getColumns = this.getColumns.bind(this);

		this.getNationalCenter = this.getNationalCenter.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"all",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],

			lab_sections_id:"all",
			lab_sections:[],

			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			convoke_places_id:"all",
			convoke_places_name:"",

			national_center_id:"all",
			national_centers:[],
			national_center_name:"",

			table_list:[],
			listado:[],
			listado_pdf:[],

			change_check: false,

			//test datatable to export
			columns:[],
			columns_default:[],
			filename:"Donaciones por Centro",
			search_by:"",
			fraction_columns:"",
			search_type:"date",

			statuses:[],
			status:"all",
			status_name:"",
			totales:{apto:0,no_apto:0,total:0},
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		this.getColumns('inicial');

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getNationalCenter();
		this.getConvokePlace();

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getColumns(start){
		this.setState({
			columns:[
				{title: "Centro",width:"0%"},
				{title: "No. Donación",width:"15%"},
				{title: "Nombres",width:"23%"},
				{title: "Tipo Extracción", width:"15%"},
				{title: "Tipo Donación", width:"15%"},
				{title: "Documento",width:"18%"},
				{title: "Grupo",width:"9%"},
				{title: "RH",width:"9%"},
				{title: "Dirigida a",width:"25%"},
				{title: "Estado",width:"10%"}
	        ]
		});

		if(start === 'inicial'){
			setTimeout(()=>{
				this.setTable();
			}, 500);
		}	
	}

	setTable(){
		this.$el = $(this.el);
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation: 'landscape',
                	//pageSize: 'A3',
                	customize: (doc) => { 
                		var i_table = 3;

                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						if(this.state.national_center_id !== "all" || this.state.convoke_places_id !== "all" || this.state.status !== "all"){
							doc.content.splice(3, 0, {
								columns:[
									this.state.national_center_id !== "all" ?
										{text: 'Centro Paciente', width:'8%'}
									: {text:"", width:0},
									this.state.national_center_id !== "all" ?
										{text: this.state.national_center_name, bold:1, margin:[0,0,0,10], width:'30%' }
									: {text:"", width:0},

									this.state.convoke_places_id !== "all" ?
										{text: 'Lugar de Colecta', width:'10%'}
									: {text:"", width:0},
									this.state.convoke_places_id !== "all" ?
										{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], width:'30%' }
									: {text:"", width:0},

									this.state.status !== "all" ?
										{text: 'Estatus', width:'8%'}
									: {text:"", width:0},
									this.state.status !== "all" ?
										{text: this.state.status_name, bold:1, margin:[0,0,0,10], width:'8%' }
									: {text:"", width:0},
								]
							});
							i_table = 4;
						}
						
						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 0){
								head.push({text:c.title, style:'tableHeader'})
							}
							
						})

						this.state.listado_pdf.unshift(head);

						doc.content[i_table].table.body = this.state.listado_pdf;
					
                		doc.content[i_table + 1] = {
							text:'Aptos: '+this.state.totales.apto+'  -  '+
							     'No Aptos: '+this.state.totales.no_apto+'  -  '+
								 'Total: '+this.state.totales.total,
							margin:[5,15,0,0],
							bold:1
            			}
            			doc.content[i_table].table.widths=["10%","20%","10%","15%","15%","5%","5%","15%","5%"];
                		doc.styles.tableHeader.fontSize = 7;
                		doc.defaultStyle.fontSize = 7; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 

                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

                	} 
            	}
            ],
			rowGroup: {
	            dataSrc: [ 0 ],
	        },
	        columnDefs: [ {
	            targets: [ 0 ],
	            visible: false
	        } ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: false,
			autoWidth: false,
			ordering:true,
			info:false,
			createdRow: function(row, data, dataIndex){
                if(data[9] === ""){
                    $('td:eq(7)', row).attr('colspan', 8);
                    $('td:eq(7)', row).attr('style', 'font-weight: bold; padding-left:62%');
            		$('td:eq(8)', row).css('display', 'none');
            		$('td:eq(2)', row).css('display', 'none');
            		$('td:eq(3)', row).css('display', 'none');
            		$('td:eq(4)', row).css('display', 'none');
            		$('td:eq(5)', row).css('display', 'none');
            		$('td:eq(6)', row).css('display', 'none');
            		$('td:eq(1)', row).css('display', 'none');
                }
            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		 // Change the fixed ordering when the data source is updated
	    table.on( 'rowgroup-datasrc', function ( e, dt, val ) {
	        table.order.fixed( {pre: [[ val, 'asc' ]]} ).draw();
	    } );
	 
	    $('a.group-by').on( 'click', function (e) {
	        e.preventDefault();
	 
	        table.rowGroup().dataSrc( $(this).data('column') );
	    } );
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'national_center_id'){
			this.setState({
				national_center_name: e.target.options[e.target.selectedIndex].text
			})
				
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'status'){
			this.setState({
				status_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.getColumns();

				this.props.waiting.handleShow('Buscando...');

				var object = {};
				object.convoke_places_id = this.state.convoke_places_id;
				object.date_start = this.state.start_date;
				object.date_end = this.state.end_date;
				object.status = this.state.status;
				object.health_facilities_id = this.state.health_facilities_id;
				object.national_center_id = this.state.national_center_id;

				fetch(Config.default.apiGateway.URL+'reports/report_donations', {
					method : 'post',
					body:JSON.stringify(object),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				})
				.then(response => {
					
					if (response !== undefined) { 
						var list = [], list_pdf = [];
						var t_apto = 0, t_no_apto =  0, t = 0;
						for (var i = 0; i < response.res.length; ++i) {
							if(response.res[i].rows.length >0){
								var obj = [];
								
								for (var j = 0; j < response.res[i].rows.length; ++j) {
									var row = [];
									row.push(
										response.res[i].national_center_name,
										response.res[i].rows[j].donation_number,
										response.res[i].rows[j].donor_name,
										response.res[i].rows[j].extraction_type,
										response.res[i].rows[j].donation_type,
										response.res[i].rows[j].document,
										response.res[i].rows[j].donor_group,
										response.res[i].rows[j].donor_rh,
										response.res[i].rows[j].patient_name,
										response.res[i].rows[j].status
									);
									list.push(row);
								}

								var totales = 'Aptos: '+response.res[i].aptos+'  -  '+
											'No Aptos: '+response.res[i].no_aptos+'  -  '+
											'Total: '+response.res[i].total;

								list.push([response.res[i].national_center_name,"","","","","","","",totales,""]);
								
							}
						};

						//listado para pdf
						for (var i = 0; i < response.res.length; ++i) {
							if(response.res[i].rows.length >0){
								var obj = [];
								obj.push({text:response.res[i].national_center_name, colSpan:9, bold:1, fillColor:'#dfdfdf'});
								list_pdf.push(obj);
								
								for (var j = 0; j < response.res[i].rows.length; ++j) {
									var row = [];
									row.push(
										{text:response.res[i].rows[j].donation_number, alignment:'center'},
										response.res[i].rows[j].donor_name,
										response.res[i].rows[j].extraction_type,
										response.res[i].rows[j].donation_type,
										response.res[i].rows[j].document,
										{text:response.res[i].rows[j].donor_group, alignment:'center'},
										{text:response.res[i].rows[j].donor_rh, alignment:'center'},
										response.res[i].rows[j].patient_name,
										response.res[i].rows[j].status
									);
									list_pdf.push(row);
								}

								var totales = 'Aptos: '+response.res[i].aptos+'  -  '+
											'No Aptos: '+response.res[i].no_aptos+'  -  '+
											'Total: '+response.res[i].total;

								list_pdf.push([{text:totales, colSpan:9, bold:1, alignment:'right'}]);
								
							}
						};


						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							listado_pdf: list_pdf,
							totales:{
								apto: response.aptos,
								no_apto: response.no_aptos,
								total: response.total
							}
						});
					}
						
				})
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: 'all'//sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

	showColumn(column_name){
    	var i =0;
      	for(i =0; i < this.state.columns.length;i++){
        	if(this.state.columns[i].column_key === column_name && this.state.columns[i].active){
          		return false;
        	}
      	} 
    	
    	return true;
 	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	getNationalCenter(){
 		fetch(Config.default.apiGateway.URL+'national_centers?option=report_donations&health_facility='+
			this.state.health_facilities_id, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					national_centers: response
				});
			}
		});
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{t('sidebar.nav.reports.donations_by_center')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_donations_by_center"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro Origen</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Centro Paciente</span>
									<select className="form-control" name="national_center_id" id="national_center_id"
										value={this.state.national_center_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.national_centers.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
									
								<div className="form-group">
									<span className="span-min">Estatus</span>
									<select className="form-control"  name="status" id="status"
										value={this.state.status} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="APTO">APTOS</option>
										<option value="NO APTO">NO APTOS</option>
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											Lista de Donantes por Hospital
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:   <Moment format="DD/MM/YYYY">{this.state.start_date}</Moment>      
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: <Moment format="DD/MM/YYYY">{this.state.end_date}</Moment> 
										</span>
									</div>
									{/*<div className="col-xs-12">
										<a className="group-by btn btn-info" data-column="0" style={{cursor:'pointer'}}>Reordenar por Centro</a>
									</div>*/}
								</div>

								<div className="col-xs-12">
									{this.state.national_center_id !== 'all' && this.state.national_center_id !== ""?
										<span>
											Centro Paciente: 
											<b style={{marginLeft:"5px"}}>{this.state.national_center_name}</b>
										</span>
									:null}

									{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
										<span style={{marginLeft:"15px"}}>
											Lugar de Colecta:  
											<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
										</span>									
									:null}

									{this.state.status !== 'all' && this.state.status !== ""?
										<span style={{marginLeft:"15px"}}>
											Estatus:   
											<b style={{marginLeft:"5px"}}> {this.state.status_name}</b>
										</span>
									:null}
								</div>

								<div className="col-xs-12" id="table-to-pdf">

									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>

								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<span className="span-min">Aptos: </span>{' '+this.state.totales.apto}
									<span className="span-min" style={{marginLeft:"5px"}}>No Aptos: </span>{' '+this.state.totales.no_apto}
									<span className="span-min" style={{marginLeft:"5px"}}>Total: </span>{' '+this.state.totales.total}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (DonationsByCenter);